import * as React from 'react';
import * as styles from './Header.css';

export interface IHeaderProps {
  title?: string;
}
export function Header({ title }: IHeaderProps) {
  return <div className={styles['container']}>{title}</div>;
}
